import { render } from "./AlertConfirmacionEliminar.vue?vue&type=template&id=130759a1&ts=true"
import script from "./AlertConfirmacionEliminar.vue?vue&type=script&lang=ts"
export * from "./AlertConfirmacionEliminar.vue?vue&type=script&lang=ts"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__